<div class='auth-dialog__content'>
  <div class="auth-dialog__content--title fk-h6 fk-mb5">
    {{ 'auth.login.header' | translate }}
  </div>

  <form [formGroup]="loginForm" (submit)='login()'>
    <fk-form-control class="auth-dialog__content--form-control fk-mb5" [label]="'form.login.label' | translate" [control]="loginForm.get('login')">
      <div class="fk-form-group">
        <input
          formControlName="login"
          class="fk-form-control"
          [disabled]="loginForm.disabled"
          [placeholder]="'form.login.placeholder' | translate"
        />
      </div>
    </fk-form-control>

    <fk-form-control class="auth-dialog__content--form-control fk-mb5" [label]="'form.password.label' | translate" [control]="loginForm.get('password')">
      <div class="fk-form-group">
        <input
          formControlName="password"
          class="fk-form-control"
          [disabled]="loginForm.disabled"
          [type]="showPassword ? 'text' : 'password'"
          [placeholder]="'form.password.placeholder' | translate"
        />
        <button
          type="button"
          class="fk-form-group--suffix fk-btn fk-btn-ghost"
          [disabled]="loginForm.disabled"
          (click)="showPassword = !showPassword"
        >
          <fk-icon
            [name]="showPassword ? 'eye' : 'eye-off'"
            [size]="20"
            [title]="(showPassword ? 'form.login.hidePassword' : 'form.login.showPassword') | translate | titlecase"
          ></fk-icon>
        </button>
      </div>
    </fk-form-control>

    <fk-form-control
      *ngIf="isVerifyRequired"
      class="auth-dialog__content--form-control fk-mb5"
      [label]="'form.otp-confirm.label' | translate"
      [control]="loginForm.get('code')"
    >
      <div class="fk-form-group">
        <input
          fkAutoFocusInput
          formControlName="code"
          class="fk-form-control"
          [placeholder]="'form.otp-confirm.placeholder' | translate"
        />
      </div>
    </fk-form-control>

    <div
      *ngIf="errorMsg"
      class="auth-dialog__error fk-caption1">
      {{ errorMsg }}
    </div>

    <button
      type='submit'
      class='fk-btn fk-btn-medium fk-btn-dark auth-dialog__content-submit-btn'
      [disabled]='loginForm.invalid || loginForm.disabled'
    >{{'auth.login.submit' | translate}}</button>
  </form>
</div>
